import { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import { TranslationService } from '../../../../../services/translation.service';
import { IconColor } from '../../Icon/icon-color.enum';
import { IconMotif } from '../../Icon/icon-motif.enum';
import { IconVariant } from '../../Icon/icon-variant.enum';
import Fact from '../Fact';

export default function SeverityAndTitleFact({ trafficSituation, className = '' }: { trafficSituation: ITrafficSituation; className?: string }): React.ReactNode | null {
  if (!trafficSituation || !trafficSituation.aiGeneratedInformation) return null;

  return (
    <Fact {...getSeverityIcon(trafficSituation.severity)} altText={getSeverityIconAltText(trafficSituation.severity)} title={getSeverityIconAltText(trafficSituation.severity)} className={className}>
      <h3>{trafficSituation.aiGeneratedInformation.summary ?? trafficSituation.title}</h3>
    </Fact>
  );
}

function getSeverityIcon(severity: string): { iconMotif: IconMotif; iconColor: IconColor; iconVariant?: IconVariant } {
  switch (severity) {
    case 'severe':
      return { iconMotif: IconMotif.Exclamation, iconColor: IconColor.Red600, iconVariant: IconVariant.HexagonFilled };
    case 'normal':
      return { iconMotif: IconMotif.Exclamation, iconColor: IconColor.Orange500, iconVariant: IconVariant.TriangleFilled };
    case 'slight':
      return { iconMotif: IconMotif.Info, iconColor: IconColor.Blue800, iconVariant: IconVariant.CircleFilled };
    default:
      return { iconMotif: IconMotif.Info, iconColor: IconColor.Blue800, iconVariant: IconVariant.CircleFilled };
  }
}

function getSeverityIconAltText(severity: string): string {
  switch (severity) {
    case 'severe':
      return TranslationService.get('common.trafficsituation.severity.severe');
    case 'normal':
      return TranslationService.get('common.trafficsituation.severity.normal');
    case 'slight':
      return TranslationService.get('common.trafficsituation.severity.slight');
    default:
      return TranslationService.get('common.trafficsituation.severity.normal');
  }
}
